type MediaFailure = {
  kind: string;
  errorCode?: string | null;
  errorMessage?: string | null;
  canRecover?: boolean;
};

export function mediaFailureMessage(task: MediaFailure): string {
  const original = task.errorMessage ?? '';
  if (['MEDIA_CONTENT_BLOCKED', 'PROVIDER_CONTENT_BLOCKED'].includes(task.errorCode ?? '')) {
    return `${original} 修改建议：先检查${['image', 'video'].includes(task.kind) ? '提示词中的动作、衣着、身体特写及参考图' : '本阶段的创作要求、人物设定和对白'}。若包含露骨细节，可改为转场、人物反应或非露骨表达，保留必要情节。服务未指明具体触发词；修改后由你重新提交。`;
  }
  if (task.kind !== 'video' || !/^UPSTREAM_HTTP_(502|503|504)$/.test(task.errorCode ?? ''))
    return original;
  // Older saved errors contain only the HTTP status. Keep newer, specific diagnostics.
  if (!/返回 HTTP (502|503|504)$/.test(original)) return original;
  return `${original}：视频服务暂时不可用或响应异常。${
    task.canRecover
      ? '原任务回执已保存，可恢复查询，无需重新生成。'
      : '未取得任务编号，结果尚未确认。请稍后核对再生成新候选，不要连续重复提交。'
  }`;
}
